import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { YoutubeDTO } from './dto/youtube.dto';


export class YTubeResponseModel extends GlobalResponseObject {
    data?: any;
    response: YoutubeDTO[];
}
export class AllYTubeResponseModel extends GlobalResponseObject{
    data?: any[];
}





